<div *ngIf="changedDto" class="changed-info-container">
  <span>{{'common.lastChanges' | translate}}: {{changedDto | qPointDateFormat}}, </span>
  <span *ngIf="userChangedBySurname && userChangedByFirstName; else noUser">{{userChangedByFirstName}}
    {{userChangedBySurname}}</span>
  <ng-template #noUser>
    <span *ngIf="serviceClientChangedByIdentifier === 'portal';else thirdPartySystem">{{'common.user' | translate}} *****</span>
    <ng-template #thirdPartySystem>{{'common.byThirdPartySystem' | translate}}</ng-template>
  </ng-template>
</div>
